import { IPRAttributes } from '@upright/common/model/input/companies/products/ipr';
import { SpecialEndUseType } from './special-end-uses';
import { SpecialAttributeType } from './special-attributes';
import { ProductTypeAttributeType } from './product-type';

export function getAttributesCount(ipr: Partial<IPRAttributes>) {
  const recyclabilityCount = ipr.Recyclability?.length || 0;
  const energySourcesCount = ipr.EnergySourcesUsed?.length || 0;
  const certificatesCount = ipr.Certifications?.length || 0;
  const targetIndustriesCount = ipr.TargetIndustry?.length || 0;
  return recyclabilityCount + energySourcesCount + certificatesCount + targetIndustriesCount;
}

export const getSpecialEndUsesFromIPR = (ipr: Partial<IPRAttributes>): SpecialEndUseType[] => {
  const attributes: SpecialEndUseType[] = [];
  if (ipr.Educational) attributes.push('Educational');
  if (ipr.ForHumanitarianAid) attributes.push('ForHumanitarianAid');
  if (ipr.ForDisabledPeople) attributes.push('ForDisabledPeople');
  if (ipr.ForLanguageMinorityGroups) attributes.push('ForLanguageMinorityGroups');
  return attributes;
};

export const getSpecialAttributesFromIPR = (ipr: Partial<IPRAttributes>): SpecialAttributeType[] => {
  const attributes: SpecialAttributeType[] = [];
  if (ipr.FollowingJournalisticEthics) attributes.push('FollowingJournalisticEthics');
  if (ipr.IsPhysicalRetail) attributes.push('IsPhysicalRetail');
  if (ipr.IsOnlineRetail) attributes.push('IsOnlineRetail');
  if (ipr.IsWholesale) attributes.push('IsWholesale');
  if (ipr.IsRental) attributes.push('IsRental');
  if (ipr.IsLeasing) attributes.push('IsLeasing');
  if (ipr.IsTrading) attributes.push('IsTrading');
  if (ipr.IsInstallationOf) attributes.push('IsInstallationOf');
  if (ipr.IsAssemblyOf) attributes.push('IsAssemblyOf');
  if (ipr.IsRepairOrMaintenanceOf) attributes.push('IsRepairOrMaintenanceOf');
  if (ipr.IsDistributionOf) attributes.push('IsDistributionOf');
  if (ipr.IsLicensingOf) attributes.push('IsLicensingOf');
  if (ipr.UltraLowCostCommerce) attributes.push('UltraLowCostCommerce');
  if (ipr.InDevelopingCountries) attributes.push('InDevelopingCountries');
  if (ipr.WithoutAnimalTesting) attributes.push('WithoutAnimalTesting');
  return attributes;
};

export const getProductTypeAttributesFromIPR = (ipr: Partial<IPRAttributes>): ProductTypeAttributeType[] => {
  const attributes: ProductTypeAttributeType[] = [];
  if (ipr.isManufactured !== undefined) attributes.push('isManufactured');
  if (ipr.Tangibility) attributes.push('Tangibility');
  if (ipr.OfferingType) attributes.push('OfferingType');
  return attributes;
};

export const getAdvancedAttributesCount = (ipr: Partial<IPRAttributes>) => {
  const specialEndUsesCount = getSpecialEndUsesFromIPR(ipr).length;
  const absentRawMaterialsCount = (ipr.MaterialsAbsences || []).length;
  const specialAttributesCount = getSpecialAttributesFromIPR(ipr).length;
  const productTypeAttributesCount = getProductTypeAttributesFromIPR(ipr).length;
  return specialEndUsesCount + absentRawMaterialsCount + specialAttributesCount + productTypeAttributesCount;
};
